import * as React from 'react';
import { Dialog } from './dialog';
import { Button } from '@material-ui/core';

export class MessageDialog extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.onCancelButtonClicked = this.onCancelButtonClicked.bind(this);
        this.onOkButtonClicked = this.onOkButtonClicked.bind(this);
    }

    private onCancelButtonClicked() {
        if (this.props.onCancelButtonClicked != null) {
            this.props.onCancelButtonClicked();
        }
    }

    private onOkButtonClicked() {
        if (this.props.onOkButtonClicked != null) {
            this.props.onOkButtonClicked();
        }
    }

    public render() {
        return (
            <Dialog desc={this.props.message} onFadeClicked={this.onCancelButtonClicked}>
                <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%'}}>
                    {this.props.cancelButtonTitle != null && (
                        <Button color="secondary" onClick={this.onCancelButtonClicked}>{this.props.cancelButtonTitle}</Button>
                    )}
                    <Button style={{marginLeft: '8px'}} color="primary" variant="contained" onClick={this.onOkButtonClicked}>{this.props.okButtonTitle}</Button>
                </div>
            </Dialog>
        )
    }

}

export interface Props {

    message: string;
    okButtonTitle: string;
    cancelButtonTitle?: string;

    onOkButtonClicked: {(): void};
    onCancelButtonClicked?: {(): void};

}

interface State {

}